import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const CommentBoxWrapper = styled.div<{ small: boolean }>`
  display: grid;
  grid-template-columns: ${({ small }) => (small ? '40px 1fr' : '1fr')};
`;

export const CommentBoxContainer = styled.div<{ small: boolean }>`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  width: ${({ small }) => (small ? 'initial' : '100%')};
  margin-top: auto;
  border: none;
  background-color: ${themeStyle.transparent};
  padding-top: 10px;
  position: ${({ small }) => (small ? 'initial' : 'sticky')};
  bottom: 0;
`;

export const ProfileImageContainer = styled.div`
  position: relative;
  height: 30px;
  width: 30px;
  margin-bottom: 5px;

  @media (max-width: 400px) {
    display: none;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  min-height: 40px;
  background: ${themeStyle.transparent};
  border-radius: 5px;
  padding-right: 6px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  gap: 10px;
  border: 1px solid ${themeStyle.varInkLight};
`;

export const DummyTextArea = styled.textarea`
  border: none;
  font-size: ${themeStyle.fontSize12};
  line-height: 1.6;
  outline: none;
  overflow: hidden;
  position: absolute;
  visibility: hidden;
  width: 100%;
`;

export const InputContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  align-self: center;
`;

export const TreeLine = styled.div<{ height: string }>`
  position: relative;
  width: 40px;
  height: 100%;

  &:after {
    content: '';
    position: absolute;
    top: ${({ height }) => (height === '23px' ? `8px` : '8px')};
    left: 13px;
    width: 20px;
    height: ${({ height }) => {
      if (height === '23px') {
        return `calc(${height} + 1px)`;
      }
      if (height === '24px') {
        return `calc(${height} - 2px)`;
      }
      return `calc(${height} - 6px)`;
    }};
    border-bottom-left-radius: 8px;
    border-bottom: 1px solid ${themeStyle.varInkLight};
    border-left: 1px solid ${themeStyle.varInkLight};
  }
`;
